"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var react_1 = __importDefault(require("react"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var useStyles = (0, system_1.makeStyles)(function (theme) { return ({
    card: {
        borderRadius: 24,
        padding: theme.go.schemes.spacing.units.L,
        backgroundColor: theme.go.schemes.colors.system.BgMinor,
    },
    warning: {
        '&$card': {
            backgroundColor: (0, utils_1.blend)(theme.go.schemes.colors.system.ControlMain, (0, utils_1.changeAlpha)(theme.go.schemes.colors.system.BgMain, 0.68)),
        },
    },
    error: {
        '&$card': {
            backgroundColor: (0, utils_1.blend)(theme.go.schemes.colors.system.BgAttention, (0, utils_1.changeAlpha)(theme.go.schemes.colors.system.BgMain, 0.68)),
        },
    },
}); });
function Card(_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'default' : _b, className = _a.className, children = _a.children, rest = __rest(_a, ["variant", "className", "children"]);
    var _c = useStyles(), card = _c.card, warning = _c.warning, error = _c.error;
    return (react_1.default.createElement("div", __assign({ className: (0, utils_1.cn)(card, className, variant === 'error' ? error : undefined, variant === 'warning' ? warning : undefined) }, rest), children));
}
exports.Card = Card;
